import { createActions, createReducer } from "../../helpers/Redux";
import initialState from "../models/myProfile";

const { actions, types } = createActions({
  myProfileInitialFetch: [],
  setItems: ["totalStudents", "max", "totalLessons"],
  uploadThumbnailRequest: ["file", "onSuccess", "onFailure"],
  deleteThumbnailRequest: ["onSuccess", "onFailure"],
  setMyProfileLoading: ["loading"],
  setAvatarError: ["error"],
  changePasswordRequest: [
    "oldPassword",
    "newPassword",
    "confirmPassword",
    "onFailure",
    "onSuccess",
  ],
});

const reducer = createReducer(initialState, {
  [types.SET_ITEMS]: (state, { payload }) => ({
    ...state,
    totalStudents: payload.totalStudents,
    max: payload.max,
    loading: false,
    initialFetchIsDone: true,
    totalLessons: payload.totalLessons,
  }),
  [types.SET_AVATAR_ERROR]: (state, { payload }) => ({
    ...state,
    avatarError: payload.error,
  }),
  [types.SET_MY_PROFILE_LOADING]: (state, { payload }) => ({
    ...state,
    loading: payload.loading,
  }),
});

export { reducer as default, types, actions };
